<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">
        TBA Participation: {{ detail.status.name }}
      </h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>TBA</b> /

      <router-link to="/tba_purchase">
        Participations
      </router-link>
      /

      <b>Details</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-2 ml-1">
      <p v-if="detail.staff.user != null" style="margin-right: 20px;">
        <b>Officer:</b> {{ detail.staff.user.name }}
      </p>
      <p v-else style="margin-right: 20px;"><b>Officer:</b></p>
      <p v-if="detail.status_id != 5 && detail.status_id != 11" style="margin-right: 20px;">
        <b>Date Taken:</b> {{ detail.updated_at | moment("Do MMMM YYYY") }}
      </p>
      <p v-if="detail.status_id == 5" style="margin-right: 20px;">
        <b>Date Completed:</b> {{ detail.updated_at | moment("Do MMMM YYYY") }}
      </p>
      <p v-if="detail.status_id == 11" style="margin-right: 20px;">
        <b>Date Cancelled:</b> {{ detail.updated_at | moment("Do MMMM YYYY") }}
      </p>
      <p v-if="detail.status_id == 5 || detail.status_id == 11" style="margin-right: 20px;">
        <b>Status:</b> {{ detail.status.name }}
      </p>
      <button class="btn btn-primary btnPrint" @click="print">Print</button>
    </div>

    <div class="row mb-4" id="print">
      <div class="col-md-12 card">
        <div class="tab-content" id="myTabContent">
          <div class="row mb-2 ml-1 printH">
            <p v-if="detail.staff.user != null" style="margin-right: 20px;">
              <b>Officer:</b> {{ detail.staff.user.name }}
            </p>
            <p v-else style="margin-right: 20px;"><b>Officer:</b></p>
            <p v-if="detail.status_id != 5 && detail.status_id != 11" style="margin-right: 20px;">
              <b>Date Taken:</b>
              {{ detail.updated_at | moment("Do MMMM YYYY") }}
            </p>
            <p v-if="detail.status_id == 5" style="margin-right: 20px;">
              <b>Date Completed:</b>
              {{ detail.updated_at | moment("Do MMMM YYYY") }}
            </p>
            <p v-if="detail.status_id == 11" style="margin-right: 20px;">
              <b>Date Cancelled:</b>
              {{ detail.updated_at | moment("Do MMMM YYYY") }}
            </p>
            <p v-if="detail.status_id == 5 || detail.status_id == 11" style="margin-right: 20px;">
              <b>Status:</b> {{ detail.status.name }}
            </p>
          </div>

          <!-- Participant Details -->

          <div class="row">
            <div class="col-md-12 font-weight-bold mb-4" style="font-size: 1.6em; padding-left: 6px;">
              Participant Details
            </div>

            <div class="col-md-6">
              <p><b>Name:</b> {{ detail.customer.user.name }}</p>

              <p><b>IC No.:</b> {{ detail.customer.ic_no }}</p>

              <p>
                <b>Date of Birth:</b>
                {{ detail.customer.date_of_birth | moment("Do MMMM YYYY") }}
              </p>

              <div v-if="detail.customer.gender == 0">
                <p><b>Gender:</b> Male</p>
              </div>
              <div v-else>
                <p><b>Gender:</b> Female</p>
              </div>

              <p>
                <b>Marital Status:</b>
                {{ detail.customer.marital_status.status }}
              </p>

              <p><b>Nationality:</b> {{ detail.customer.nationality.name }}</p>

              <!-- <p>
              <b>Race:</b> {{ detail.customer.race.name }}
            </p> -->

              <p><b>Religion:</b> {{ detail.customer.religion.name }}</p>

              <p><b>Email:</b> {{ detail.customer.user.email }}</p>
            </div>

            <div class="col-md-6">
              <p><b>Customer Code:</b> {{ detail.customer.cfid }}</p>

              <p>
                <b>Registration Date:</b>
                {{
                  detail.customer.created_at | moment("Do MMMM YYYY, h:mm:ss a")
                }}
              </p>

              <p><b>Occupation:</b> {{ detail.customer.occupation }}</p>

              <p><b>Mobile No.:</b> {{ detail.customer.mobile_number }}</p>

              <!-- <p>
              <b>Office No.:</b> {{ detail.customer.office_number }}
            </p> -->

              <p><b>Address:</b> {{ detail.customer.address }}</p>

              <p><b>Postal Code:</b> {{ detail.customer.postal_code }}</p>

              <p><b>Office Address:</b> {{ detail.customer.office_address }}</p>
            </div>
          </div>

          <div class="mt-3 mb-4 border-top"></div>

          <!-- Purchase Details -->
          <div class="row">
            <div class="col-md-12 font-weight-bold mb-4" style="font-size: 1.6em; padding-left: 6px;">
              Participation Details
            </div>

            <div class="col-md-6">
              <p><b>Order ID:</b> {{ detail.bpgs_id }}</p>

              <p><b>Product:</b> {{ detail.product.name }}</p>

              <p>
                <b>Date Participated:</b>
                {{ detail.created_at | moment("Do MMMM YYYY, h:mm:ss a") }}
              </p>

              <p><b>Status:</b> {{ detail.status.name }}</p>

              <p><b>Payment Status:</b> {{ detail.payment_status.name }}</p>

              <p><b>Total Amount:</b> $ {{ detail.price }}</p>

              <br />

              <!-- Receipt -->
              <div v-if="detail.status_id !== 5 && detail.status_id !== 11" class="btnPrint">
                <form class="form" @submit.prevent="handleReceiptSubmit">
                  <div class="form-group col-10">
                    <label>Upload Receipt Link</label>
                    <input type="file" id="receipt" ref="receipt" class="form-control"
                      v-on:change="handleReceiptUpload" />
                    <br />
                    <progress max="100" :value.prop="uploadPercentageReceipt"></progress>
                  </div>
                  <input type="submit" class="btn btn-primary mb-2" />
                </form>
              </div>
              <div v-if="receiptList !== ''" class="form-group btn btnPrint">
                <button @click="
                  downloadReceipt(receiptList.id, receiptList.download_link)
                  " class="btn btn-primary" :disabled="checkReceipt(receiptList.download_link)">
                  Download Receipt
                </button>
              </div>
            </div>
            <div class="col-md-6">
              <span v-for="(travelData, index) in detail.additional_data" :key="index">
                <p>
                  <b>{{ travelData.meta_label }}:</b>
                  {{ travelData.meta_value }}
                </p>
              </span>
            </div>
            <br />
            <div class="col-md-12">
              <h4>Traveller(s) Details</h4>
              <div class="table-responsive">
                <table id="travellers_tbl" class="display table table-striped table-bordered"
                  style="width:100%; text-align: center;">
                  <tr>
                    <th>Name</th>
                    <th>Passport</th>
                    <th>Age</th>
                    <th>Gender</th>
                    <th>Type</th>
                  </tr>
                  <tr v-for="(traveller, index) in detail.travellers_data" :key="index">
                    <td>{{ traveller.name }}</td>
                    <td>{{ traveller.passport }}</td>
                    <td>{{ traveller.age }}</td>
                    <td>{{ traveller.gender }}</td>
                    <td>{{ traveller.type }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>

          <div class="mt-3 mb-4 border-top"></div>

          <!-- Certificate -->
          <div class="row mb-2">
            <div class="col-md-12 font-weight-bold mb-4" style="font-size: 1.6em; padding-left: 0px;">
              Certificate
            </div>
            <!-- Upload -->
            <div v-if="detail.status_id !== 5 && detail.status_id !== 11" class="col-md-6 btnPrint">
              <form class="form" @submit.prevent="handleSubmit">
                <div class="form-group col-10">
                  <label>Upload Certificate Link</label>
                  <input type="file" id="file" ref="file" v-on:change="handleFileUpload" class="form-control" />
                  <br />
                  <progress max="100" :value.prop="uploadPercentage"></progress>
                  <br />
                  <!-- <label>Starting Date</label>
                  <input type="date" class="form-control" v-model="starting_date"/>
                  <br>
                  <label>Expiry Date</label>
                  <input type="date" class="form-control" v-model="expiry_date" />
                  <br> -->
                  <input class="form-control" placeholder="Certificate No." v-model="cert_no" />
                  <br />
                  <textarea rows="3" class="form-control" placeholder="Person Covered" v-model="description"></textarea>
                </div>
                <input type="submit" class="btn btn-primary mb-2" />
              </form>
            </div>

            <!-- Certificate List -->
            <div class="col-md-6">
              <div class="table-responsive">
                <table id="cert_tbl" class="display table table-striped table-bordered"
                  style="width:100%; text-align: center;">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Certificate No.</th>
                      <th>Person Covered</th>
                      <!-- <th>Starting Date</th>
                    <th>Expiry Date</th> -->
                      <th class="btnPrint">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(certificate, index) in certificateList" v-bind:key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ certificate.cert_no }}</td>
                      <td>{{ certificate.description }}</td>
                      <!-- <td>{{certificate.starting_date | moment("Do MMMM YYYY") }}</td>
                    <td>{{certificate.expiry_date | moment("Do MMMM YYYY")}}</td> -->
                      <td class="btnPrint">
                        <button class="btn btn-primary btn-block mr-1" @click="
                          downloadCertificate(
                            certificate.id,
                            certificate.download_link
                          )
                          " style="background-color: #78BE20; border-color: #78BE20;"
                          :disabled="certificate.download_link === null">
                          Download Certificate
                        </button>

                        <button v-if="detail.status_id != 5" class="btn btn-danger btn-block"
                          @click="deleteCertificate(certificate.id)">
                          Delete Certificate
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- <div  class="col-md-12 printH">
            <div class="table-responsive">
              <table id="cert_tbl" class="display table table-striped table-bordered" style="width:100%; text-align: center;">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Certificate No.</th>
                    <th>Person Covered</th>
                    <th>Starting Date</th>
                    <th>Expiry Date</th>
                    <th class="btnPrint">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(certificate, index) in certificateList" v-bind:key="index">
                    <td>{{index + 1}}</td>
                    <td>{{certificate.cert_no}}</td>
                    <td>{{certificate.description}}</td>
                    <td>{{certificate.starting_date | moment("Do MMMM YYYY") }}</td>
                    <td>{{certificate.expiry_date | moment("Do MMMM YYYY")}}</td>
                    <td class="btnPrint">
                      <button class="btn btn-primary btn-block mr-1" @click = "downloadCertificate(certificate.id, certificate.download_link)" style="background-color: #78BE20; border-color: #78BE20;" :disabled = "certificate.download_link === null">Download Certificate</button>

                      <button v-if="detail.status_id != 5" class="btn btn-danger btn-block" @click = "deleteCertificate(certificate.id)">Delete Certificate</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- Button -->
    <div class="text-center mb-4">
      <button v-if="cancelBtn === true" @click="cancelParticipation(detail.id)" class="btn btn-lg btn-danger mr-2">
        Cancel Participation
      </button>
      <!-- <button v-if="detail.status_id !== 5 && detail.status_id !== 11" @click = "proceedToComplete(detail.id)" class="btn btn-lg btn-primary" :disabled = "checkParticipation(certDownloadLink, receiptList)">Participation Complete</button> -->
      <button v-if="detail.status_id !== 5 && detail.status_id !== 11" @click="proceedToComplete(detail.id)"
        class="btn btn-lg btn-primary" :disabled="enableButton">
        Participation Complete
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { setTimeout } from "timers";

export default {
  name: "tba_details",
  components: {},

  data() {
    return {
      additional_data: [],
      remove_data: [],
      content: {
        title: "",
        type: "",
        travel_destination: "",
        from: "",
        to: "",
        person_covered: [],
        member_id: "",
        cert_no: ""
      },
      t_count: 0,
      metaArray: [],
      detail: {
        status_id: 5,
        customer: {
          user: {
            name: "",
            email: ""
          },
          date_of_birth: "",
          ic_no: "",
          gender: "",
          marital_status: "",
          cfid: "",
          mobile_number: "",
          office_number: "",
          address: "",
          postal_code: "",
          office_address: "",
          nationality: "",
          race: "",
          religion: "",
          occupation: "",
          created_at: ""
        },
        product: {
          name: ""
        },
        created_at: "",
        status: {
          id: "",
          name: ""
        },

        certificates: [
          {
            cert_no: ""
          }
        ],
        details_meta: [],
        staff: {
          user: {
            name: ""
          }
        }
      },
      id: "",
      file: "",
      uploadPercentage: 0,
      receipt: "",
      uploadPercentageReceipt: 0,
      starting_date: "",
      expiry_date: "",
      certificateList: [],
      certDownloadLink: [],
      cert_no: "",
      description: "",
      receiptList: [],
      cancelBtn: false
    };
  },

  computed: {
    enableButton() {
      if (this.receiptList !== "" && this.certificateList.length !== 0) {
        return false;
      }
      return true;
    }
  },

  methods: {
    print() {
      // Pass the element id here
      this.$htmlToPaper("print");
    },

    checkParticipation(certLink, receiptData) {
      if (receiptData !== "") {
        if (certLink === 0) {
          return true;
        }
      } else {
        return false;
      }
    },

    checkReceipt(link) {
      if (link !== "") {
        return false;
      } else {
        return true;
      }
    },

    loadDetails() {
      let token = localStorage.getItem("token");
      this.id = this.$route.params.id;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/tba/purchase/show/" + this.id, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.detail = res.data;
            this.additional_data = res.data.additional_data;
            this.loadReceiptList();
            this.loadCertificateList();
            // Cancel Button
            // only appear if status !== Cancelled
            // only appear if certificate is not yet active, i.e. the departure date has not reached
            if (res.data.status.id !== 11) {
              let detailsMeta = res.data.details_meta;

              for (let i = 0; i < detailsMeta.length; i++) {
                if (this.cancelBtn === true) {
                  break;
                }

                if (detailsMeta[i].meta_key === "from_date") {
                  var today = new Date();
                  var today =
                    today.getFullYear() +
                    "-" +
                    (today.getMonth() + 1) +
                    "-" +
                    today.getDate();

                  var departure_date = detailsMeta[i].meta_value
                    .split(/\//)
                    .reverse()
                    .join("/"); // rearrange becomes yyyy/mm/dd
                  var departure_date = new Date(departure_date);
                  var departure_date =
                    departure_date.getFullYear() +
                    "-" +
                    (departure_date.getMonth() + 1) +
                    "-" +
                    departure_date.getDate();

                  // console.log(today < departure_date)
                  if (today < departure_date) {
                    this.cancelBtn = true;
                  }
                  continue;
                }
              }
            }
          });
      }
    },

    cancelParticipation(id) {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"]
        }).then(confirm => {
          if (confirm) {
            axios
              .post(
                "/detail/cancel/" + id,
                {
                  _method: "patch"
                },
                {
                  headers: {
                    Authorization: "Bearer " + token
                  }
                }
              )
              .then(res => {
                if (res.data.success === true) {
                  swal({
                    icon: "success",
                    text: "Successful!"
                  }).then(ok => {
                    this.$router.push({ name: "tba_purchase" });
                  });
                } else {
                  swal({
                    icon: "error",
                    text: res.data.message
                  });
                }
              });
          } else {
            swal({
              icon: "info",
              text: "Cancelled"
            });
          }
        });
      }
    },

    proceedToComplete(id) {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"]
        }).then(confirm => {
          if (confirm) {
            axios
              .post(
                "/detail/approve/" + id,
                {
                  _method: "patch"
                },
                {
                  headers: {
                    Authorization: "Bearer " + token
                  }
                }
              )
              .then(res => {
                if (res.data.authorised === false) {
                  swal({
                    icon: "error",
                    text: "Not authorised"
                  });
                } else {
                  if (res.data.success === true) {
                    swal({
                      icon: "success",
                      text: "Successful!"
                    }).then(ok => {
                      this.$router.push({ name: "tba_purchase" });
                    });
                  } else {
                    swal({
                      icon: "error",
                      text: res.data.message
                    });
                  }
                }
              });
          } else {
            swal({
              icon: "info",
              text: "Cancelled"
            });
          }
        });
      }
    },

    // Certificate

    loadCertificateList() {
      let token = localStorage.getItem("token");
      this.id = this.$route.params.id;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/certificate/detail/" + this.id, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.certificateList = res.data;
            this.destroyDatatable();
            if (this.certificateList.length === 0) {
              this.certDownloadLink = 0;
            } else {
              for (let i = 0; i < this.certificateList.length; i++) {
                this.certDownloadLink = this.certificateList[i].download_link;
              }
            }
          })
          .then(function () {
            $("#cert_tbl").DataTable({
              iDisplayLength: 5,
              aLengthMenu: [[5, 10, 15, 30, 50], [5, 10, 15, 30, 50]]
            });
          });
      }
    },

    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },

    handleSubmit() {
      if (this.file !== "" && this.cert_no !== "" && this.description !== "") {
        this.storeCertificate();
      } else {
        swal({
          title: "Try Again",
          text: "All fields are required.",
          icon: "error"
        });
      }
    },

    storeCertificate() {
      let token = localStorage.getItem("token");
      this.id = this.$route.params.id;

      var date = new Date();
      var currentDatetime = date.getTime();
      var ex_date = date.setFullYear(date.getFullYear() + 1);

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .post(
            "/certificate/store/" + this.id,
            {
              // starting_date: currentDatetime,
              starting_date: this.starting_date,
              expiry_date: this.expiry_date,
              cert_no: this.cert_no,
              description: this.description
            },
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            this.uploadCertificate(res.data.certificate.id);
          });
      }
    },

    uploadCertificate(cert_id) {
      let token = localStorage.getItem("token");

      let formdata = new FormData();

      formdata.append("certificate", this.file);

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .post("/certificate/upload/" + cert_id, formdata, {
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: function (progressEvent) {
              this.uploadPercentage = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              );
            }.bind(this)
          })
          .then(res => {
            swal({
              title: "",
              text: "Successful!",
              icon: "success"
            }).then(ok => {
              this.loadDetails();
              this.loadCertificateList();
            });
          })
          .catch(function () { });
      }
    },

    downloadCertificate(id, link) {
      let token = localStorage.getItem("token");

      if (link != null) {
        let arrLink = link.split("/");
        // check if has token
        if (token !== null) {
          token = JSON.parse(token);
          token = token.access_token;

          axios
            .get("/certificate/download/" + id, {
              headers: {
                Authorization: "Bearer " + token
              },
              responseType: "blob"
            })
            .then(res => {
              this.certificate = res.data;
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", arrLink[3]);
              document.body.appendChild(link);
              link.click();
            });
        }
      } else {
        swal({
          icon: "warning",
          text: "File is not found"
        });
      }
    },

    deleteCertificate(certificate_id) {
      let token = localStorage.getItem("token");
      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .delete("/certificate/delete/" + certificate_id, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            swal({
              text: "Successful!",
              icon: "success"
            });
            this.loadCertificateList();
          })
          .catch(function () {
            swal({
              icon: "error",
              text:
                "encountered problem deleting, check connection and try again"
            });
          });
      }
    },

    // Receipt
    loadReceiptList() {
      let token = localStorage.getItem("token");
      this.id = this.$route.params.id;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        axios
          .get("/receipts/detail/" + this.id, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.receiptList = res.data;
          });
      }
    },

    handleReceiptUpload() {
      this.receipt = this.$refs.receipt.files[0];
    },

    handleReceiptSubmit() {
      if (this.receipt !== "") {
        this.storeReceipt();
      } else {
        swal({
          title: "Try Again",
          text: "Please select a file.",
          icon: "error"
        });
      }
    },

    storeReceipt() {
      let token = localStorage.getItem("token");
      this.id = this.$route.params.id;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        if (!this.receiptList.id) {
          axios
            .post(
              "/receipts/store/" + this.id,
              {},
              {
                headers: {
                  Authorization: "Bearer " + token
                }
              }
            )
            .then(res => {
              this.uploadReceipt(res.data.receipt.id);
            });
        } else {
          this.uploadReceipt(this.receiptList.id);
        }
      }
    },

    uploadReceipt(receipt_id) {
      let token = localStorage.getItem("token");

      let formdata = new FormData();

      formdata.append("receipt", this.receipt);

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .post("/receipts/upload/" + receipt_id, formdata, {
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: function (progressEvent) {
              this.uploadPercentageReceipt = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              );
            }.bind(this)
          })
          .then(res => {
            // console.log("SUCCESS!!")

            swal({
              title: "",
              text: "Successful!",
              icon: "success"
            }).then(ok => {
              // window.location.reload()
              this.loadReceiptList();
              this.loadDetails();
              this.loadCertificateList();
            });
          })
          .catch(function () {
            // console.log("FAIL!")
          });
      }
    },

    destroyDatatable() {
      $("#cert_tbl")
        .DataTable()
        .destroy();
    },

    downloadReceipt(id, link) {
      let token = localStorage.getItem("token");

      if (link != null) {
        let arrLink = link.split("/");
        // check if has token
        if (token !== null) {
          token = JSON.parse(token);
          token = token.access_token;

          axios
            .get("/receipts/download/" + id, {
              headers: {
                Authorization: "Bearer " + token
              },
              responseType: "blob"
            })
            .then(res => {
              this.receipt = res.data;
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", arrLink[3]);
              document.body.appendChild(link);
              link.click();
            });
        }
      } else {
        swal({
          icon: "warning",
          text: "No file uploaded"
        });
      }
    }
  },

  mounted() {
    this.loadDetails();
    this.loadReceiptList();
    this.loadCertificateList();
    // setTimeout(function() {
    //   $("#cert_tbl").DataTable({
    //     "iDisplayLength": 5,
    //     "aLengthMenu": [[5, 10, 15, 30, 50], [5, 10, 15, 30, 50]],
    //   });
    // }, 3000);
  }
};
</script>

<style>
.printH {
  display: none;
}
</style>
